export default __webpack_public_path__ + "static/media/mindshatter.d089811a.png";